import React, { useState, useEffect } from 'react'
import axios from "../url-access/axios";
import './main.css';

const Banner = (props) => {
    const [randomMovie, setMovies] = useState([]);

    useEffect(() => {
        async function fetchData() {
            const request = await axios.get(props.fetchUrl);
            // console.log(request);
            setMovies(request.data.results[Math.floor(Math.random() * request.data.results.length)]);
            return request;
        }
        fetchData();
    }, [props.fetchUrl]);

    // console.log(randomMovie);

    function shortenDescription(string, n){
        return string?.length>n? string.substr(0,n-1)+"...":string;
    }
    return (
        <>
            <header className="banner-outer"  
            style={{ 
                    backgroundColor:"black",
                    backgroundSize: "cover", 
                    backgroundImage: `url("https://image.tmdb.org/t/p/original${randomMovie.backdrop_path}")`,
                    backgroundPosition: "center center" }}
                    >
                <div className="banner-content">
                    <div className="banner-title">
                        {randomMovie?.title || randomMovie?.name || randomMovie?.original_name}
                    </div>
                    <div className="banner-buttons">
                        <button className="banner-button">Play</button>
                        <button className="banner-button">MyList</button>
                    </div>
                    <h1 className="banner-details">
                        {shortenDescription(randomMovie?.overview || "details", 200)}
                    </h1>
                </div>
                <div className="banner-fade-bottom">
                </div>
            </header>

        </>
    )
}

export default Banner